import { getGlobalHeadersAsObject } from "../global-headers";

export interface PeopleAlsoViewedPerson {
	id: number;
	name: string;
	url: string;
	user_hash: string;
	vanity_name: string | null;
	headline: string;
}

export interface PeopleAlsoViewed {
	id: number;
	person_from: PeopleAlsoViewedPerson;
	person_to: PeopleAlsoViewedPerson;
	created: string;
}

export interface PeopleAlsoViewedResponse {
	count: number;
	next: string | null;
	previous: string | null;
	results: PeopleAlsoViewed[];
}

export type PeopleAlsoViewedDirection = "outgoing" | "incoming";

export const getPeopleAlsoViewedByPersonId = (
	personId: number,
	direction: PeopleAlsoViewedDirection = "outgoing"
): Promise<PeopleAlsoViewedResponse> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`getPeopleAlsoViewedByPersonId called with invalid argument personId '${personId}'. Expected number`
		);
	}

	const url = new URL(
		`/api/v2/persons/${personId}/people_also_viewed/`,
		window.location.origin
	);
	url.searchParams.set("direction", direction);

	return fetch(url.toString(), {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => {
		if (!res.ok) {
			throw new Error(`Failed to fetch people also viewed: ${res.statusText}`);
		}
		return res.json();
	});
};
